import { useEffect, useRef } from 'react';

// Screens call tourEvent('search-built') etc. when the user completes an
// action a lesson step is waiting for. No-op when no lesson is running.
export const TOUR_EVENT = 'mm-tour';

export function tourEvent(name: string) {
  try {
    window.dispatchEvent(new CustomEvent(TOUR_EVENT, { detail: name }));
  } catch {
    /* very old browsers: lessons just won't auto-advance */
  }
}

// "Do it for me" buttons on a lesson card send a lesson action; the screen
// that owns the thing performs it (useLessonAction) and then usually sends
// a tourEvent so the lesson moves on.
export const LESSON_ACTION = 'mm-lesson-action';

export function lessonAction(name: string) {
  try {
    window.dispatchEvent(new CustomEvent(LESSON_ACTION, { detail: name }));
  } catch { /* ignore */ }
}

export function useLessonAction(name: string, handler: () => void) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    const on = (e: Event) => { if ((e as CustomEvent).detail === name) ref.current(); };
    window.addEventListener(LESSON_ACTION, on);
    return () => window.removeEventListener(LESSON_ACTION, on);
  }, [name]);
}
